import React, { useEffect, useState } from "react";
import { isDarkMode, toggleTheme } from "../utils/theme";

// A single fixed toggle that floats over every view. Desktop only (hidden on mobile, where it
// would overlap the bottom tab bar) - on mobile the theme is changed from Profile > Appearance.
// The actual theme is applied by utils/theme.js (the `dark` class on <html>); this just flips it
// and reflects the current state in its icon.
export default function ThemeToggle() {
  const [dark, setDark] = useState(isDarkMode());

  // Re-sync on mount (in case the inline pre-paint script set a different initial theme) and
  // whenever the theme is changed elsewhere (e.g. the profile setting).
  useEffect(() => {
    setDark(isDarkMode());
    const onChange = () => setDark(isDarkMode());
    window.addEventListener("gc:themechange", onChange);
    return () => window.removeEventListener("gc:themechange", onChange);
  }, []);

  const handleClick = () => {
    setDark(toggleTheme() === "dark");
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      aria-label={dark ? "Switch to light mode" : "Switch to dark mode"}
      title={dark ? "Switch to light mode" : "Switch to dark mode"}
      className="fixed bottom-[calc(1rem+env(safe-area-inset-bottom))] right-4 z-50 hidden sm:inline-flex h-11 w-11 items-center justify-center rounded-full border border-gray-300 bg-white/90 text-gray-700 shadow-md backdrop-blur hover:bg-gray-100 dark:border-gray-600 dark:bg-gray-800/90 dark:text-gray-200 dark:hover:bg-gray-700"
    >
      <i className={`not-italic ${dark ? "fi fi-rr-sun" : "fi fi-rr-moon"}`} aria-hidden="true" />
    </button>
  );
}
